import { BusinessListParamsTypes, BusinessItemTypes } from './types';

import axiosInstance from 'services/common/instance';

export const getBusinessListService = async (params?:BusinessListParamsTypes)
: Promise<PaginationData<BusinessItemTypes[]>> => {
  const response = await axiosInstance.get('nhdt-business', { params });
  return response.data;
};

export const getBusinessDetailService = async (slug: string)
: Promise<BusinessItemTypes> => {
  const response = await axiosInstance.get(`nhdt-business/${slug}`);
  return response.data.data;
};
